import { SCHEDULED_COLLECTIONS as SCHEDULED_COLLECTIONS_FIELD } from "./";
import { ALL } from "../strings";

const OPTIONS = {
  0: { label: ALL },
  1: {
    label: "Only",
    functionParameters: {
      testFn: (route) =>
        (route.scheduledCollections || []).length > 0 &&
        (route.stops || []).length === 0,
    },
  },
  2: {
    label: "Both",
    functionParameters: {
      testFn: (route) =>
        (route.scheduledCollections || []).length > 0 &&
        (route.stops || []).length > 0,
    },
  },
  3: {
    label: "None",
    functionParameters: {
      testFn: (route) =>
        (route.scheduledCollections || []).length === 0 &&
        (route.stops || []).length > 0,
    },
  },
};

export const SCHEDULED_COLLECTIONS = {
  title: "Scheduled Collections",
  field: SCHEDULED_COLLECTIONS_FIELD,
  values: Object.keys(OPTIONS).map((option) => ({
    value: option,
    ...OPTIONS[option],
  })),
  filterCallback: ({ route, testFn }) => testFn(route),
  volumeOverlayRequired: true,
};
